export const CURRENCY_TABLE = 'b870ae1b-4815-46ee-9059-987b03093c49';
export const FUNCTION_LEVEL_TABLE = 'c6bf2dc7-4942-4498-ab19-488a7d37073d';
export const JOB_TITLE_TABLE = '5f9a30ba-9659-4c60-ae2d-9d90ba109386';
export const REGULATION_TABLE = '94507e65-1554-4c47-898d-5b0eef86e057';
export const ANONYMOUS_REGULATION_TABLE = '22c41bd3-bd35-459e-9692-a75d27e6d196';
export const SECTOR_TABLE = 'f30135d2-fa0c-47ce-8151-3e65cd242e77';
export const STATION_TABLE = 'd37b14c7-f9e7-4103-a8ca-0ee844a50f37';
export const PERSON_TYPE_TABLE = '90d50986-5994-4b9d-a9c1-8e75a8542be2';
export const STATUS_TABLE = '890449cd-ca3b-4888-9989-8fbb34188eb4';
export const EMPLOYER_TABLE = 'd28e87fc-91b7-4bef-a422-1c98a7e3b49d';
export const GENDER_TABLE = '4d74fe93-c48e-4cff-8bc1-2afc550c51e6';
export const COUNTRY_TABLE = '10f342b5-afc8-4604-bb32-9c19bef61272';
export const LAST_NAME_PREFERENCE_TABLE = '6c230de0-4da7-412b-8cdd-d2becc952c62';
export const UPDATE_REASON_TABLE = '65c85dc3-442b-4a28-acf1-b212d126116d';
export const PHONE_COUNTRY_CODE_TABLE = 'd5121d6d-56d2-4b20-9177-89324a331956';
